export const LAYOUT_SIDE_WIDTH = 268;